import {
    IBasicOrderInfo,
    IOrderRow,
    ISms,
    Recipients,
    INewEmail,
    ICreateEmailCommand,
    IRecipient,
    IEmailFormState,
    INewSms,
    ISmsFormState,
    ICreateSmsCommand,
    IEditOrderRowViewModel
} from './Types';
import BasicOrderInfoApi from './BasicOrderInfoApi';
import IReducerReturn from '../../../../store/IReducerReturn';
import * as ActionTypes from './ActionTypes';

function createOrderRowSuccess(
    result: IOrderRow,
    submitted: IOrderRow
): IReducerReturn<IOrderRow> {
    return { type: ActionTypes.CREATE_ORDER_ROW_SUCCESS, result: result, submitted: submitted };
}

export function createOrderRow(orderId: number, data: IOrderRow) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        BasicOrderInfoApi.createOrderRow(orderId, data).then((result: IOrderRow) => {
            dispatch(createOrderRowSuccess(result, data));
            return result;
        });
}

function viewSuccess(result: IBasicOrderInfo): IReducerReturn {
    return { type: ActionTypes.VIEW_BASIC_INFO_SUCCESS, result: result };
}

export function view(orderId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        BasicOrderInfoApi.view(orderId).then((result: any) => {
            dispatch(viewSuccess(result));
            return result;
        });
}

function editOrderRowSuccess(result: IEditOrderRowViewModel): IReducerReturn {
    return { type: ActionTypes.EDIT_ORDER_ROW_SUCCESS, result };
}

export function editOrderRow(orderId: number, rowId: number) {
    return (dispatch: (result: any) => void) =>
        BasicOrderInfoApi.editOrderRow(orderId, rowId).then((result: IEditOrderRowViewModel) => {
            dispatch(editOrderRowSuccess(result));
            return result;
        });
}

function updateOrderRowSuccess(
    result: IOrderRow,
    submitted?: IOrderRow
): IReducerReturn<IOrderRow> {
    return { type: ActionTypes.UPDATE_ORDER_ROW_SUCCESS, result: result, submitted: submitted };
}

export function removeOrderRow(orderId: number, orderRow: IOrderRow) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        BasicOrderInfoApi.deleteOrderRow(orderId, orderRow.id).then((result: IOrderRow) => {
            dispatch(updateOrderRowSuccess(result));
        });
}

export function updateOrderRow(orderId: number, orderRow: IOrderRow) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        BasicOrderInfoApi.updateOrderRow(orderId, orderRow).then((result: IOrderRow) => {
            dispatch(updateOrderRowSuccess(result, orderRow));
            return result;
        });
}

function newEmailSuccess(result: INewEmail): IReducerReturn {
    return { type: ActionTypes.NEW_EMAIL_SUCCESS, result: result };
}

export function newEmail(orderId: number, recipient: Recipients): any {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        BasicOrderInfoApi.newEmail(orderId, recipient).then((result: INewEmail) => {
            dispatch(newEmailSuccess(result));
        });
}

export function createEmail(
    orderId: number,
    formState: IEmailFormState,
    recipients: IRecipient[],
    attachments: number[]
): any {
    return (dispatch: (result: any) => void, getState: (error: any) => void) => {
        let recipient = recipients[formState.recipient - 1];
        let data: ICreateEmailCommand = {
            sender: formState.sender,
            recipient: recipient ? recipient.contactInfo : '',
            cc: formState.cc,
            desiredSendTime: formState.desiredSendTime,
            subject: formState.subject,
            body: formState.body,
            attachments: attachments
        };

        return BasicOrderInfoApi.createEmail(orderId, data);
    };
}

function getSmsSuccess(result: ISms[]): IReducerReturn {
    return { type: ActionTypes.VIEW_SMS_SUCCESS, result: result };
}

export function viewSms(orderId: number): any {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        BasicOrderInfoApi.getSms(orderId).then((result: ISms[]) => {
            dispatch(getSmsSuccess(result));
        });
}

function newSmsSuccess(result: INewSms): IReducerReturn {
    return { type: ActionTypes.NEW_SMS_SUCCESS, result: result };
}

export function newSms(orderId: number, recipient: Recipients): any {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        BasicOrderInfoApi.newSms(orderId, recipient).then((result: INewSms) => {
            dispatch(newSmsSuccess(result));
        });
}

export function createSms(
    orderId: number,
    formState: ISmsFormState,
    recipients: IRecipient[]
): any {
    return (dispatch: (result: any) => void, getState: (error: any) => void) => {
        let recipient = recipients[formState.recipient - 1];
        let data: ICreateSmsCommand = {
            recipient: recipient ? recipient.contactInfo : '',
            recipientType: recipient.recipientType.value,
            cc: formState.cc,
            desiredSendTime: formState.desiredSendTime,
            body: formState.body
        };
        return BasicOrderInfoApi.createSms(orderId, data);
    };
}

function updatePreventEmailsToBrokerSuccess(result: boolean): IReducerReturn {
    return {
        type: ActionTypes.UPDATE_PREVENT_EMAILS_TO_BROKER_SUCCESS,
        result: result
    };
}

export function updatePreventEmailsToBroker(orderId: number, preventEmails: boolean): any {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        BasicOrderInfoApi.updatePreventEmailsToBroker(orderId, preventEmails).then(() => {
            dispatch(updatePreventEmailsToBrokerSuccess(preventEmails));
        });
}

function updatePreventEmailsToPhotographerSuccess(result: boolean): IReducerReturn {
    return {
        type: ActionTypes.UPDATE_PREVENT_EMAILS_TO_PHOTOGRAPHER_SUCCESS,
        result: result
    };
}

export function updatePreventEmailsToPhotographer(orderId: number, preventEmails: boolean): any {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        BasicOrderInfoApi.updatePreventEmailsToPhotographer(orderId, preventEmails).then(() => {
            dispatch(updatePreventEmailsToPhotographerSuccess(preventEmails));
        });
}

function updatePreventCommunicationToPropertyOwnerSuccess(result: boolean): IReducerReturn {
    return {
        type: ActionTypes.UPDATE_PREVENT_COMMUNICATION_TO_PROPERTY_OWNER_SUCCESS,
        result: result
    };
}

export function updatePreventCommunicationToPropertyOwner(
    orderId: number,
    preventEmails: boolean
): any {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        BasicOrderInfoApi.updatePreventCommunicationToPropertyOwner(orderId, preventEmails).then(
            () => {
                dispatch(updatePreventCommunicationToPropertyOwnerSuccess(preventEmails));
            }
        );
}

export function preCheckUnbooking(calendarItemId: number): any {
    return BasicOrderInfoApi.preCheckUnbooking(calendarItemId).then((result) => {
        return result;
    });
}

function unbookPhotographerSuccess(result: any): any {
    return { type: ActionTypes.UNBOOK_PHOTOGRAPHER_SUCCESS, result: result };
}

export function unbookPhotographer(calendarItemId: number): any {
    return (dispatch: (result: any) => void) =>
        BasicOrderInfoApi.unbookPhotographer(calendarItemId).then((result) => {
            dispatch(unbookPhotographerSuccess(result));
            return result;
        });
}

function unbookStylingUserSuccess(result: any): any {
    return { type: ActionTypes.UNBOOK_STYLINGUSER_SUCCESS, result: result };
}

export function unbookStylingUser(calendarItemId: number): any {
    return (dispatch: (result: any) => void) =>
        BasicOrderInfoApi.unbookStylingUser(calendarItemId).then((result) => {
            dispatch(unbookStylingUserSuccess(result));
        });
}

function markAsUnreadSuccess(result: any): any {
    return { type: ActionTypes.MARK_AS_UNREAD_ORDER_SUCCESS, result: result };
}

export function markAsUnread(orderId: number): any {
    return (dispatch: (result: any) => void) =>
        BasicOrderInfoApi.markAsUnread(orderId).then((result) => {
            dispatch(markAsUnreadSuccess(result));
        });
}

function unarchivePhotoSuccess(result: any): any {
    return { type: ActionTypes.UNARCHIVE_PHOTO_ORDER_SUCCESS, result: result };
}

export function unarchivePhoto(orderId: number, site: number): any {
    return (dispatch: (result: any) => void) =>
        BasicOrderInfoApi.unarchivePhoto(orderId, site).then((result) => {
            dispatch(unarchivePhotoSuccess(result));
        });
}

function unarchivePlanSuccess(result: any): any {
    return { type: ActionTypes.UNARCHIVE_PLAN_ORDER_SUCCESS, result: result };
}

export function unarchivePlan(orderId: number, site: number): any {
    return (dispatch: (result: any) => void) =>
        BasicOrderInfoApi.unarchivePlan(orderId, site).then((result) => {
            dispatch(unarchivePlanSuccess(result));
        });
}

function updateOwnerCommunicationLanguageSuccess(result: any): any {
    return {
        type: ActionTypes.UPDATE_OWNER_COMMUNICATION_LANGUAGE_SUCCESS,
        result: result
    };
}

export function updateOwnerCommunicationLanguage(orderId: number, language: string): any {
    return (dispatch: (result: any) => void) =>
        BasicOrderInfoApi.updateOwnerCommunicationLanguage(orderId, language).then((result) => {
            dispatch(updateOwnerCommunicationLanguageSuccess(result));
        });
}

function UpdateIsDirectDeliverySuccess(result: any): any {
    return {
        type: ActionTypes.UPDATE_IS_DIRECT_DELIVERY_SUCCESS,
        result: result
    };
}

export function UpdateIsDirectDelivery(orderId: number, isDirectDelivery: boolean): any {
    return (dispatch: (result: any) => void) =>
        BasicOrderInfoApi.UpdateIsDirectDelivery(orderId, isDirectDelivery).then((result) => {
            dispatch(UpdateIsDirectDeliverySuccess(result));
        });
}

export function updateImageEditorFirmSuccess(result: any): any {
    return {
        type: ActionTypes.UPDATE_IMAGE_EDITOR_FIRM_SUCCESS,
        result: result
    };
}

export function updateImageEditorFirm(orderId: number, imageEditorFirmId: number): any {
    return (dispatch: (result: any) => void) =>
        BasicOrderInfoApi.updateImageEditorFirm(orderId, imageEditorFirmId).then((result) => {
            dispatch(updateImageEditorFirmSuccess(imageEditorFirmId));
        });
}

function updateImageEditorSuccess(result: any): any {
    return { type: ActionTypes.UPDATE_IMAGE_EDITOR_SUCCESS, result: result };
}

export function updateImageEditor(orderId: number, imageEditorId: number): any {
    return (dispatch: (result: any) => void) =>
        BasicOrderInfoApi.updateImageEditor(orderId, imageEditorId).then((result) => {
            dispatch(updateImageEditorSuccess(imageEditorId));
        });
}

function updateExtraDeliveryRecipientsSuccess(result: any): any {
    return {
        type: ActionTypes.UPDATE_EXTRA_DELIVERY_RECIPIENTS_SUCCESS,
        result: result
    };
}

export function updateExtraDeliveryRecipients(
    orderId: number,
    extraDeliveryRecipients: string
): any {
    return (dispatch: (result: any) => void) =>
        BasicOrderInfoApi.updateExtraDeliveryRecipients(orderId, extraDeliveryRecipients).then(
            (result) => {
                dispatch(updateExtraDeliveryRecipientsSuccess(extraDeliveryRecipients));
            }
        );
}

function setOrderToUploaderSuccess(result: any): any {
    return { type: ActionTypes.SET_ORDER_TO_UPLOADER_SUCCESS, result: result };
}

export function setOrderToUploader(orderId: number): any {
    return (dispatch: (result: any) => void) =>
        BasicOrderInfoApi.setOrderToUploader(orderId).then((result) => {
            dispatch(setOrderToUploaderSuccess(result));
        });
}
function updateOrderStateSuccess(result: any): any {
    return { type: ActionTypes.UPDATE_ORDER_STATE_SUCCESS, result: result };
}

export function updateOrderState(orderId: number, orderState: number): any {
    return (dispatch: (result: any) => void) =>
        BasicOrderInfoApi.updateOrderState(orderId, orderState).then((result) => {
            dispatch(updateOrderStateSuccess(result));
        });
}

export function canRemovePlanOrder(orderId: number): any {
    return (dispatch: (result: any) => void) => BasicOrderInfoApi.canRemovePlanOrder(orderId);
}

function lockPhotographerSuccess() {
    return { type: ActionTypes.LOCK_PHOTOGRAPHER_SUCCESS, result: {} };
}

function unlockPhotographerSuccess() {
    return { type: ActionTypes.UNLOCK_PHOTOGRAPHER_SUCCESS, result: {} };
}

export function lockPhotographer(orderId: number): any {
    return (dispatch: (result: any) => void) =>
        BasicOrderInfoApi.lockPhotographer(orderId).then(() => dispatch(lockPhotographerSuccess()));
}

export function unlockPhotographer(orderId: number): any {
    return (dispatch: (result: any) => void) =>
        BasicOrderInfoApi.unlockPhotographer(orderId).then(() =>
            dispatch(unlockPhotographerSuccess())
        );
}

export function downloadFile(warmStorageReference: string) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        BasicOrderInfoApi.downloadFile(warmStorageReference).then((result: any) => {
            dispatch(downloadFilesSuccess(result));
        });
}
function downloadFilesSuccess(result: any) {
    return { type: ActionTypes.DOWNLOAD_ATTACHED_FILE_SUCCESS, result: result };
}
